import { Component, OnInit, Input, Output, Inject, EventEmitter, ViewChild, ElementRef, SimpleChanges, NgZone, Renderer2, ChangeDetectorRef } from '@angular/core';
import { OwlOptions, CarouselComponent, SlidesOutputData, CarouselModule } from 'ngx-owl-carousel-o';
import { AssetsService } from "../../core/services/assets.service";
import { PlaylistService, UserService } from '../../core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment-timezone';
import { CatlougeTypeConstants } from "../../core/constants";

import { CommonService } from "../../core/services/common.service";
import { PageTitleService } from '../../page-services/page-title.service';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LocalStorageService } from '../../core/services/local-stroage.service'

import { customOptionsForBigSlider, customOptionsForEightMiniSlider, customOptionsForFourMiniSlider, customOptionsForSevenMiniSlider, customOptionsForSixMiniSlider, customOptionsForThreeMiniSlider, customOptionsForFiveMiniSlider } from '../owl-slider-config';
import { VideoPlayerService } from "../../core/services/videoPlayerService";
import { environment } from '../../../environments/environment';
import { EventTrackingService } from '../../page-services/google/event-tracking.service';
import { ImageManipulationComponent } from '../../core/components/image-manipulation/image-manipulation.component';
import { ItemHoverComponent } from '../item-hover/item-hover.component';
import { LoginRegisterComponent } from '../../auth/login-register/login-register.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import Swiper from 'swiper';
import { register } from 'swiper/element/bundle';

import 'swiper/css';
// import 'swiper/css/effect-coverflow';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

register();
@Component({

  selector: 'app-owl-slider',
  imports: [ImageManipulationComponent, CommonModule, CarouselModule, ItemHoverComponent, LoginRegisterComponent, TranslateModule],
  templateUrl: './owl-slider.component.html',
  styleUrl: './owl-slider.component.css',

})
export class OwlSliderComponent {
  @ViewChild('swiperContainer') swiperContainer!: ElementRef;
  @Input() owlOption: any;
  @Input() data: any = {};
  @Input() owlSliderData: any;
  @Input() page_view: string = '';
  @Input() languages: any;

  @ViewChild('owlCarousel', { static: false }) owlCarousel!: CarouselComponent;
  @ViewChild('owlCarousel', { read: ElementRef }) owlCarouselEl!: ElementRef;


  customOptionsForBigSlider = customOptionsForBigSlider;
  customOptionsForFourMiniSlider = customOptionsForFourMiniSlider;
  customOptionsForFiveMiniSlider = customOptionsForFiveMiniSlider;
  customOptionsForSevenMiniSlider = customOptionsForSevenMiniSlider;
  customOptionsForSixMiniSlider = customOptionsForSixMiniSlider;
  customOptionsForThreeMiniSlider = customOptionsForThreeMiniSlider;
  customOptionsForEightMiniSlider = customOptionsForEightMiniSlider;

  @Output() deleteRecentWatch: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteContinueWatching: EventEmitter<any> = new EventEmitter<any>();
  @Output() itemHoverClicked = new EventEmitter<any>();
  userInfo: any;
  currentTime: number = Math.floor(Date.now() / 1000);
  totalPlayed: any = 0;
  routeName: string = '';
  categoryId: any;
  playList: any;
  owlSlides: boolean = false;
  setPlayListItem: any;
  @ViewChild('closeAddtoWatchListModal') closeAddtoWatchListModal!: ElementRef;
  @ViewChild('closeContinueModal') closeContinueModal!: ElementRef;
  @ViewChild('addToWatchListSuccess') addToWatchListSuccess!: ElementRef;
  @ViewChild('itemAddedIntoWach') itemAddedIntoWach!: ElementRef;
  @ViewChild('removeToWatchListSuccessModal') removeToWatchListSuccessModal!: ElementRef;

  progrssBarValue: number = 0;
  progressInc: number = 0;
  playListId: string = '';
  error_String: any;
  error_code: any;
  removeItemFromDetail: any;
  assets_hover: boolean = false;
  hoveredItemId: any;
  streamInfo: any;
  addedAssetIndex: any;
  playListAvailable: boolean = false;
  playlist: any;
  tempAsset_id: any;
  deletedItem: any;
  deleteAsset_id: any;
  thumbnailType: any;
  thumbnailClass: string = '';
  notFoundImg: string = "landscape";
  assetImgParam: any;
  showViewAll: number = 4;

  isCircle: any;
  enlargedCircle: any;
  previewData: any;
  playermodal: any = [];
  checkPrview: any;
  hoverAndExpend: any;
  nameOutsideOverlay: any;
  blankSliderCount!: number;
  isPreviewVideoMuted: boolean = true;

  currentHoveredIndex: any;
  assetHeight: any;
  assetWidth: any;
  expandWidth: any;
  hoverExitTimeout: any;
  firstSlideIndex!: number;
  lastSlideIndex!: number;
  freeIcon: string = environment.freeIcon;
  paidIcon: string = environment.paidIcon;
  hoveredAssetCode: any | null = null;
  hover_debounce_time: any;
  bgImage: string = '';

  constructor(
    public AssetsService: AssetsService,
    public UserService: UserService,
    public route: ActivatedRoute,
    public router: Router,
    private modalService: NgbModal,
    public playListService: PlaylistService,
    public commonService: CommonService,
    public pageTitleService: PageTitleService,
    @Inject(DOCUMENT) private document: Document,
    public localStorageService: LocalStorageService,
    private googleEvent: EventTrackingService,
    public VideoPlayerService: VideoPlayerService,
    private renderer: Renderer2,
    private ngZone: NgZone,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {

    this.router.events.subscribe((res) => {

    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'].currentValue) {
      let assets_length = this.data.assets.length;
      // if(this.data.assets.length  && this.data?.assets?.[this.data.assets.length-1].code == 'testcode') {
      //     assets_length = assets_length +1;
      // }
      this.blankSliderCount = this.owlOption.items - assets_length;
    }
  }

  ngOnInit() {

    setTimeout(() => {
      const lastSlide = document.querySelector('.new_asset_expend_type .owl-item.lastActiveItem');
      const sliderContainer = document.querySelector('.new_asset_expend_type')!;

      // Add event listeners for hover effect on the last slide
      lastSlide?.addEventListener('mouseenter', () => {
        sliderContainer.classList.add('expend_left');
      });

      lastSlide?.addEventListener('mouseleave', () => {
        sliderContainer.classList.remove('expend_left');
      });
    }, 3500);

    this.router.events.subscribe((res) => {
      this.routeName = this.router.url;
    });


    this.userInfo = JSON.parse(localStorage.getItem('userInfo')!);
    if (this.userInfo) {
      this.playListId = localStorage.getItem('playListId')!;
    }

    this.data = this.data;

    this.owlSliderData = this.owlSliderData;
    // Format the Time to display inside the template
    if (this.data.category_type === "continue-watching") {
      this.data.category_name = this.translate.instant('continueWatching');

      this.data.assets.forEach((item: any) => {
        if (item.duration && item.playing_duration) {
          const remainingSeconds = Math.max(item.duration - item.playing_duration, 0);

          const hours = Math.floor(remainingSeconds / 3600); // 1
          const minutes = Math.floor((remainingSeconds % 3600) / 60); // 1
          const seconds = remainingSeconds % 60;

          // item.remaining_time = `${hours ? hours + 'h ' : ''}${minutes > 0 ? minutes + 'm' : '' }${minutes === 0 && hours === 0 ? seconds + 's' : '' } Left`;

          const timeUnits = this.translate.instant('time_units');

          let hoursLabel = hours ? timeUnits.h : '';
          let minutesLabel = minutes > 0 ? timeUnits.m : '';
          let secondsLabel = (minutes === 0 && hours === 0) ? timeUnits.s : '';

          const timeString = this.translate.instant('remaining_time', {
            hours: hours ? hours + '' : '',
            minutes: minutes > 0 ? minutes + '' : '',
            seconds: (minutes === 0 && hours === 0) ? seconds + '' : '',
            hoursLabel,
            minutesLabel,
            secondsLabel
          });

          item.remaining_time = timeString.trim();
        }
      });
    }

    // this.thumbnailType = this.data.thumbnail_type?.slug;

    if (!this.data.thumbnail_type || (this.data.thumbnail_type && Object.keys(this.data.thumbnail_type).length === 0)) {
      this.thumbnailType = 'landscape';
    } else {
      this.thumbnailType = this.data.thumbnail_type.slug;
    }

    if (this.data.more_like) {
      this.thumbnailType = 'portrait';
    }
    if (this.data.display_numbering === 'yes' && this.data.thumbnail_type?.slug === "portrait") {
      this.thumbnailType = 'numbercategory';
    }
    if (this.data.category_type != 'category' && this.thumbnailType === 'portrait' && this.commonService.isLandscapePriority()) {
      this.thumbnailType = 'landscape';
    }

    switch (this.thumbnailType) {
      case 'landscape':
        this.owlOption = customOptionsForFiveMiniSlider;
        this.assetImgParam = { 'width': 512, 'height': 288 };
        this.thumbnailClass = 'landscape_assets';
        this.notFoundImg = 'landscape';
        this.showViewAll = 5;
        // this.hoverAndExpend = this.data.he_templatetype != '' ? this.data.he_templatetype == 'hover' ? 'new_asset_hover_type' : 'new_asset_hover_type' : '';
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;
      case 'enlarged-landscape':
        this.owlOption = customOptionsForFourMiniSlider;
        this.assetImgParam = { 'width': 608, 'height': 342 };
        this.thumbnailClass = 'enlarged_landscape_assets';
        this.notFoundImg = 'enlarged_landscape';
        this.showViewAll = 4;
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;
      case 'stretched-landscape':
        this.owlOption = customOptionsForFiveMiniSlider;
        this.assetImgParam = { 'width': 592, 'height': 259 };
        this.thumbnailClass = 'stretched_landscape_assets';
        this.notFoundImg = 'stretched_landscape';
        this.showViewAll = 5;
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;

      case 'portrait':
        this.owlOption = customOptionsForSevenMiniSlider;
        this.assetImgParam = { 'width': 400, 'height': 600 };
        this.thumbnailClass = 'portrait_assets';
        this.notFoundImg = 'portrait';
        this.showViewAll = 7;
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;
      case 'enlarged-portrait':
        this.owlOption = customOptionsForSixMiniSlider;
        this.assetImgParam = { 'width': 600, 'height': 900 };
        this.thumbnailClass = 'portrait_assets';
        this.notFoundImg = 'portrait';
        this.showViewAll = 5;
        this.hoverAndExpend = 'new_asset_expend_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;

      case 'square':
        this.owlOption = customOptionsForSevenMiniSlider;
        this.assetImgParam = { 'width': 500, 'height': 500 };
        this.thumbnailClass = 'square_assets';
        this.notFoundImg = 'square';
        this.showViewAll = 7;
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;
      case 'enlarged-square':
        this.owlOption = customOptionsForFiveMiniSlider;
        this.assetImgParam = { 'width': 600, 'height': 600 };
        this.thumbnailClass = 'enlarged_square_assets';
        this.notFoundImg = 'enlarged_square';
        this.showViewAll = 5;
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;
      case 'circular':
        this.owlOption = customOptionsForSevenMiniSlider;
        this.assetImgParam = { "roundCrop": true, 'width': 500, 'height': 500 };
        this.thumbnailClass = 'circular_assets';
        this.notFoundImg = 'circle';
        this.showViewAll = 7;
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;
      case 'enlarged-circle':
        this.owlOption = customOptionsForSixMiniSlider;
        this.assetImgParam = { "roundCrop": true, 'width': 600, 'height': 600 };
        this.thumbnailClass = 'enlarged-circular_assets';
        this.notFoundImg = 'circle';
        this.showViewAll = 6;
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;

      case 'numbercategory':  // NEW CASE for numbering
        this.owlOption = customOptionsForFiveMiniSlider; // customize slider if needed
        this.assetImgParam = { width: 400, height: 600 }; // example
        this.thumbnailClass = 'numbercategory_assets';
        this.notFoundImg = 'portrait';
        this.showViewAll = 5;
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = 'number_overlay';
        //       setTimeout(() => {
        //     const owlItems = document.querySelectorAll(`.${this.thumbnailClass} .owl-item`);
        //     if (owlItems.length >= 10) {
        //         const tenthItem = owlItems[9]; // 10th item (index 9)
        //         tenthItem.classList.add('tenth-item');
        //     }
        // }, 0);

        //     setTimeout(() => {
        //     const owlItems = document.querySelectorAll(`.${this.thumbnailClass} .owl-item`);
        //     if (owlItems.length > 0) {
        //         const lastItem = owlItems[owlItems.length - 1] as HTMLElement; // ✅ cast to HTMLElement
        //         const normalWidth = lastItem.getBoundingClientRect().width;
        //         lastItem.style.width = normalWidth + 80 + 'px';
        //     }
        // }, 0);
        break;

      default: this.thumbnailClass = 'landscape_assets';
        this.assetImgParam = { 'width': 512, 'height': 288 };
        this.owlOption = customOptionsForFiveMiniSlider;
        this.showViewAll = 5;
        this.notFoundImg = 'landscape';
        this.hoverAndExpend = 'new_asset_hover_type';
        this.nameOutsideOverlay = this.data.he_displaytext != '' ? this.data.he_displaytext_layout?.toLowerCase() == 'overlay' ? 'name_overlay' : 'name_outside' : '';

        break;
    }
    let assets_length = this.data.assets.length;
    // if(this.data.assets.length && this.data?.assets?.[this.data.assets.length-1].code == 'testcode') {

    //     assets_length = assets_length +1;
    // }
    this.blankSliderCount = this.owlOption.items - assets_length;

    this.owlSlides = this.data.assets && this.data.assets.length >= 4 ? true : false;

    if (this.data && this.data.assets)
      this.data.assets.forEach((ele: any, index: any) => {
        ele.category_slug = this.data?.category_slug ? this.data?.category_slug : 'random';
        if (ele.type == 'livetv') {

          // Check if `end_timestamp` is in seconds (Unix timestamp) or milliseconds (common in many systems).
          let endTime = moment.unix(parseInt(ele.end_timestamp) / 1000); // Convert if it's in milliseconds
          let currentTime = moment(); // Get the current time

          // Calculate the difference in minutes between the two times
          let diff = moment.duration(endTime.diff(currentTime)).minutes();

          // Update the asset's total played time
          this.data.assets[index].totalPlayed = ele.duration - diff;

        }

      });
  }

  slides: string[] = [];
  currentBgImage = '';
  swiper: any;

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.data?.assets?.length > 0) {
        this.currentBgImage = `url(${this.data.assets[0].image_landscape})`;
        this.initSwiper();
      }
    }, 300);
  }
  private initSwiper() {
    this.swiper = new Swiper(this.swiperContainer && this.swiperContainer.nativeElement, {
      effect: "coverflow",
      speed: 700,
      grabCursor: true,
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      coverflowEffect: {
        rotate: 0,
        stretch: 650,
        depth: 250,
        modifier: 1,
        slideShadows: false,
      },
      navigation: {
        nextEl: ".swiper-button-next", // ✅ must match class name
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        slideChange: () => {
          this.ngZone.run(() => {
            if (this.swiper && this.data.assets?.length) {
              const activeIndex = this.swiper.realIndex % this.data.assets.length;
              const activeSlideUrl = this.data.assets[activeIndex].image_landscape;
              this.currentBgImage = `url(${activeSlideUrl})`;
            }
          });
        },
      },
    });
  }

  onCarouselInitialized(event: SlidesOutputData) {
    this.firstSlideIndex = event.startPosition!;
    this.lastSlideIndex = event.startPosition + this.owlOption.items - 1;

    setTimeout(() => {
      const allSlides = this.owlCarouselEl.nativeElement.querySelectorAll('.owl-stage .owl-item');

      allSlides.forEach((slide: any, index: any) => {
        this.renderer.removeClass(slide, 'firstActiveItem');
        this.renderer.removeClass(slide, 'lastActiveItem');
        if (this.firstSlideIndex == index) {
          this.renderer.addClass(slide, 'firstActiveItem');
        }
        if (this.lastSlideIndex == index) {
          this.renderer.addClass(slide, 'lastActiveItem');
        }
      });

      if (this.data.thumbnail_type && this.data.thumbnail_type.slug === 'enlarged-portrait') {
        const owlItem: HTMLImageElement | null = this.owlCarouselEl.nativeElement.querySelector('.owl-item .new_asset_img img');
        if (owlItem) {
          const measure = () => {
            this.assetWidth = owlItem.offsetWidth;
            const ratio = owlItem.naturalWidth && owlItem.naturalHeight
              ? owlItem.naturalHeight / owlItem.naturalWidth
              : 3 / 2;
            this.assetHeight = Math.round(this.assetWidth * ratio);
            this.expandWidth = this.assetHeight ? (this.assetHeight * 16 / 9 + (this.owlOption?.margin || 10)) : 450;

            const assetImages = this.owlCarouselEl.nativeElement.querySelectorAll('.new_asset_img');
            assetImages.forEach((slide: any) => {
              this.renderer.setStyle(slide, 'height', this.assetHeight + 'px');
              this.renderer.setStyle(slide, 'width', this.assetWidth + 'px');
            });
          };

          if (owlItem.complete && owlItem.naturalWidth) {
            measure();
          } else {
            const onDone = () => this.ngZone.run(measure);
            owlItem.addEventListener('load', onDone, { once: true });
            owlItem.addEventListener('error', onDone, { once: true });
          }
        }
      }
    }, 100);
  }

  counter(count: number): any[] {
    return Array(count).fill(0).map((x, i) => i);
  }

  onCarouselTranslated(event: SlidesOutputData) {
    if (
      this.firstSlideIndex == event.startPosition &&
      this.lastSlideIndex == event.startPosition + this.owlOption.items - 1
    ) {
      return;
    }
    this.firstSlideIndex = event.startPosition!;
    this.lastSlideIndex = event.startPosition + this.owlOption.items - 1;

    const allSlides = this.owlCarouselEl.nativeElement.querySelectorAll('.owl-stage .owl-item');

    allSlides.forEach((slide: any, index: any) => {
      this.renderer.removeClass(slide, 'firstActiveItem');
      this.renderer.removeClass(slide, 'lastActiveItem');
      if (this.firstSlideIndex == index) {
        this.renderer.addClass(slide, 'firstActiveItem');
      }
      if (this.lastSlideIndex == index) {
        this.renderer.addClass(slide, 'lastActiveItem');
      }
    });
  }

  liniarProgressBar() {
    this.progressInc = 0;
    let progrssInterval = setInterval(() => {
      this.progrssBarValue = this.progressInc * 10;

      if (this.progressInc >= 10) {
        clearInterval(progrssInterval);
      }
      this.progressInc++;
    }, 500)

  }

  setDeleteItemForDelete(item: any) {
    localStorage.setItem('deleteItem', item);
  }

  getRemainingTime(item: any) {
    const remainingTime = moment.utc(moment.duration(item.duration - item.stop, 'minutes').asMilliseconds()).format('h[h]:m[m] Left');
    return remainingTime;
  }

  deleteWatch(e: any, item: any) {
    e.stopPropagation();
    this.removeItemFromDetail = item;
    this.deleteRecentWatch.emit(item);
    
    // this.closeContinueModal.nativeElement.click();
    this.document.getElementById('removeContinueModal')!.style.display = 'block';
    setTimeout(() => {
      this.document.getElementById('removeContinueModal')!.style.display = 'none';
    }, 3500);

  }

  openMOdelWindow(content: any) {

  }

  redirectUrl(data: any, content: any) {
    this.userInfo = localStorage.getItem('userInfo');
    data.continue_watching = false;
    if (this.userInfo) {
      let itemForDetailPage = {
        code: data.code,
        type: data.type,
      }
      let pagename: any = this.strToLower(this.data.category_name);
      this.page_view = this.page_view + '_' + pagename.split(/\s/).join('');
      if (data.asset_cat_type == 'recentlywatched') {

        this.commonService.goToDetail(data, this.page_view);

      } else {
        // check continue watch data for series, series_name get only in continue watching 
        if (data?.series_name) {

          data.continue_watching = true;
          // data.code = data.series_code;
          // data.name = data.series_name;
        }
        this.commonService.goToDetail(data, this.page_view);

      }
    } else {
      this.commonService.setDetailRedirectParams(data);
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      }, (reason) => {
      });

      // this.router.navigateByUrl('/login');
    }
  }

  viewall(data: any) {
    let viewAlldParams: any = {
      categoryId: data.category_type == 'continue-watching' ? 'continue-watching' : data.category_mongo_id
    }

    if (data.category_code == "HCTG043") {
      viewAlldParams['type'] = 'livetv'
    }

    this.routeName = this.router.url;
    if (this.routeName == '/') {
      viewAlldParams['homecatid'] = data.category_mongo_id;
      viewAlldParams['catlogue'] = CatlougeTypeConstants.catlogue;
    }
    if (this.routeName == '/livetv') {
      viewAlldParams['genre'] = data.genre_id;
      viewAlldParams['type'] = 'livetv';
      viewAlldParams['language_id'] = this.languages.toString();
      viewAlldParams['catlogue'] = CatlougeTypeConstants.catlogue;
    }

    if (this.routeName == '/movies') {
      viewAlldParams['genre'] = data.genre_id;
      viewAlldParams['type'] = 'movie';
      viewAlldParams['catlogue'] = CatlougeTypeConstants.catlogue;
    }

    if (this.routeName == '/tvshows') {

      viewAlldParams['show_id'] = data.category_mongo_id;
      viewAlldParams['genre'] = data.genre_id;
      viewAlldParams['type'] = 'tvshow';
      viewAlldParams['catlogue'] = CatlougeTypeConstants.catlogue;

    }

    if (this.routeName == '/videos') {
      viewAlldParams['category_code'] = data.category_code;
      viewAlldParams['type'] = 'vod';
      viewAlldParams['catlogue'] = CatlougeTypeConstants.catlogue;
    }
    viewAlldParams['type'] = data.tab_slug;
    this.router.navigate(['/viewall'], { queryParams: viewAlldParams })
  }

  AddToPlayListItems(e: any, item: any, content: any) {
    e.stopPropagation();
    this.routeName = this.router.url;
    if (this.userInfo && Object.keys(this.userInfo.result).length > 0) {
      this.setPlayListItem = item;
      let userUnique = '';
      if (this.userInfo.result.register_by == "mobile") {
        userUnique = this.userInfo.result.mobile;
      } else {
        userUnique = this.userInfo.result.emailaddress;
      }

      this.googleEvent.eventEmitter("Watchlist", "Video_view", userUnique + '-' + item.code + '-' + item.name, 0, userUnique, userUnique + '-' + item.code + '-' + item.name);

      let addToplayListParams = {
        playlistid: this.playListId ? this.playListId : '',
        catlogue: CatlougeTypeConstants.catlogue,
        plateform: "web",
        playingtype: "Video",
        assetId: item.asset_mongo_id ? item.asset_mongo_id : item._id,
        show_id: item.tvshowId ? item.tvshowId : '',
        assetType: item.type ? item.type : '',
        action: "saveAssetInPlaylist",
      }


      if (this.routeName == '/') {
        this.addedAssetIndex = this.data.assets.findIndex((d: any) => d['asset_mongo_id'] == item.asset_mongo_id)
      } else if (this.routeName == '/tvshows') {
        this.addedAssetIndex = this.data.assets.findIndex((d: any) => d['asset_mongo_id'] == item.asset_mongo_id)
      } else if (this.routeName == '/movies') {
        this.addedAssetIndex = this.data.assets.findIndex((d: any) => d['_id'] == item._id)
      } else if (this.routeName == '/livetv') {
        this.addedAssetIndex = this.data.assets.findIndex((d: any) => d['_id'] == item._id)
      }

      let urlEncodedToplayListParams = this.UserService.convertoJSONToUrlEncoded(addToplayListParams);
      if ((item.asset_mongo_id ? item.asset_mongo_id : item._id) != undefined) {

        this.playListService.addToPlayList(urlEncodedToplayListParams).subscribe((data) => {
          this.error_code = data.error_code;
          if (data.error_code == '200') {
            this.data.assets[this.addedAssetIndex].is_watchlist_added = true;
            this.document.getElementById('itemAddSuccessMsg')!.innerHTML = `Successfully added to Watchlist.`;

          }
          if (data.error_code == '209') {
            this.data.assets[this.addedAssetIndex].is_watchlist_added = false;
            this.deleteWatchListItem(item);
          }
          this.addToWatchListSuccess.nativeElement.click();
          setTimeout(() => {
            this.document.getElementById('closeAddToWatchList')!.click();
          }, 1500);


        });
      }


    } else {
      // this.router.navigateByUrl('/login');
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      }, (reason) => {
      });
    }
  }

  addRemoveFromWatchlist(item: any, button: HTMLButtonElement) {

    button.disabled = true;

    if (item.is_watchlist_added == 0) {
      let params = {
        type: item.type,
        code: item.code,
      };
      this.AssetsService.addToWatchList(params).subscribe(
        (data) => {
          if (data.response_code === 200 || data.response_code === 201) {
            item.is_watchlist_added = 1;
            button.disabled = false;
          }
        },
        (error) => {
          console.error('Error adding to watchlist:', error);
          button.disabled = false;
        }
      );
    } else {
      let params = {
        code: [item.code],
      };
      this.AssetsService.deleteFromWatchlist(params).subscribe(
        (data) => {
          if (data.response_code === 200 || data.response_code === 201) {
            item.is_watchlist_added = 0;
            button.disabled = false;
          }
        },
        (error) => {
          console.error('Error deleting from watchlist:', error);
          button.disabled = false;
        }
      );
    }
  }

  item_hover_enter(asset: any, i: any) {
    const id = 'hoverPreviewVideo' + asset.code + asset?.category_slug;
    const el = document.getElementById(id);
    // preview video  playing of same content
    if (el) {
      return
    }
    this.assets_hover = true;
    // set time out until 'assets_hover' class append
    this.hover_debounce_time = setTimeout(() => {
      clearTimeout(this.hover_debounce_time);
      const id = 'item_expend' + asset.code + asset?.category_slug;
      const el = document.getElementById(id);
      if (el && el.classList.contains('assets_hover')) {
        this.hoveredAssetCode = {
          ...asset,
          item_hover: true
        };
        localStorage.setItem('item_hover', 'true');
      }

    }, 1000);
    if (i === this.lastSlideIndex + 1) {
      return;
    }
    if (this.data.thumbnail_type && this.data.thumbnail_type.slug === 'enlarged-portrait') {
      if (this.hoverExitTimeout) clearTimeout(this.hoverExitTimeout);

      this.currentHoveredIndex = i;
      const allSlides = this.owlCarouselEl.nativeElement.querySelectorAll('.owl-stage .owl-item');

      allSlides.forEach((slide: any, index: any) => {
        if (index === i) {
          // Increase the width of the hovered slide
          this.renderer.setStyle(slide, 'width', this.expandWidth + 'px');
        } else {
          // Decrease the width of all other slides
          this.renderer.setStyle(slide, 'width', this.assetWidth + 'px');
        }
      });

      const owlStage = this.owlCarouselEl.nativeElement.querySelector('.owl-stage');
      const style = window.getComputedStyle(owlStage);
      const currentMarginLeft = parseFloat(style.getPropertyValue('margin-left').replace('px', '')) || 0;
      if (i === this.lastSlideIndex) {
        const translateWidth = this.expandWidth - this.assetWidth - (this.owlOption?.margin || 10);
        setTimeout(() => {
          this.renderer.setStyle(owlStage, 'margin-left', `-${translateWidth}px`);
        }, 0);
      } else if (i === this.lastSlideIndex - 1) {
        // Check the current margin-left value of the owl-stage
        const style = window.getComputedStyle(owlStage);
        const currentMarginLeft = parseFloat(style.getPropertyValue('margin-left').replace('px', '')) || 0;

        if (currentMarginLeft === 0) {
          const translateWidth = this.assetWidth ? (this.assetWidth - (this.owlOption?.margin * 6 || 60)) : 150;
          setTimeout(() => {
            this.renderer.setStyle(owlStage, 'margin-left', `-${translateWidth}px`);
          }, 0);
        }
      } else if (i === this.firstSlideIndex) {
        setTimeout(() => {
          this.renderer.setStyle(owlStage, 'margin-left', `0px`);
        }, 0);
      } else if (i === this.firstSlideIndex + 1 && (currentMarginLeft < 0)) { // this.assetWidth + (this.owlOption?.margin || 10)
        const translateWidth = this.assetWidth ? (this.assetWidth + (this.owlOption?.margin || 10)) : 100;
        setTimeout(() => {
          this.renderer.setStyle(owlStage, 'margin-left', `-${translateWidth}px`);
        }, 0);
      }
    }



    // Check if the player is already initialized
    if (asset?.code == this.checkPrview || videojs.getPlayers()[`hoverPreviewVideo${asset?.code}`]) {
      // console.log('return from item_hover_enter\n', 'item_hover_enter checkPrview:', this.checkPrview, '\nitem_hover_enter player:', videojs.getPlayers()[`hoverPreviewVideo${asset?.code}`]);
      return;
    }

    let assetDetail = {
      "code": asset.code,
    }

    let assetInfo = this.UserService.convertoJSONToUrlEncoded(assetDetail);
    return
    this.VideoPlayerService.playPreview(assetInfo).subscribe(
      (playObj) => {
        this.previewData = playObj.result;
        let videoPlayUrl: any;
        if (
          // this.previewData.cloud_front &&
          // Object.keys(this.previewData.cloud_front).length > 0 &&
          this.previewData.cloudfront_key_pair_id != "" && this.previewData.video_url != "" && this.previewData.cloudfront_policy != "" && this.previewData.cloudfront_signature != ""
        ) {
          setTimeout(() => {
            this.checkPrview = asset.code;
          }, 5000);
          setTimeout(() => {
            videoPlayUrl = this.previewData.cloud_front
              ? this.previewData.cloud_front.video_url
              : this.previewData.video_url; //this.previewData.cloud_front.video_url;

            this.setCookie(
              "CloudFront-Key-Pair-Id",
              this.previewData.cloud_front
                ? this.previewData.cloud_front.cloudfront_key_pair_id.trim()
                : this.previewData.cloudfront_key_pair_id.trim(),
              1
            );
            this.setCookie(
              "CloudFront-Policy",
              this.previewData.cloud_front
                ? this.previewData.cloud_front.cloudfront_policy.trim()
                : this.previewData.cloudfront_policy.trim(),
              1
            );
            this.setCookie(
              "CloudFront-Signature",
              this.previewData.cloud_front
                ? this.previewData.cloud_front.cloudfront_signature.trim()
                : this.previewData.cloudfront_signature.trim(),
              1
            );
            ("http://j-cdr.digivive.com/HLS_Aaj/Aaj.m3u8");

            let new_source = {
              // //sample source
              // sources: [
              //   {
              //     type: 'video/mp4',
              //     src: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
              //   },
              // ],
              sources: [{ src: videoPlayUrl, type: "application/x-mpegURL" }],
              controls: false,
              autoplay: true,
              withCredentials: true,
              crossDomain: true,
              fluid: true,
              controlBar: {
                children: [
                  // "playToggle",
                  // "volumeMenuButton",
                  // "durationDisplay",
                  // "timeDivider",
                  // "currentTimeDisplay",
                  // "progressControl",
                  // "remainingTimeDisplay",
                  // "fullscreenToggle"
                ]
              },
            };

            this.playermodal = videojs("hoverPreviewVideo" + asset.code, new_source);

            this.playermodal.userActive(false);
            this.playermodal.muted(true);
            this.playermodal.on("ended", (event: any) => {
              videojs("hoverPreviewVideo" + asset.code).dispose();
              this.checkPrview = "no";
              this.isPreviewVideoMuted = true;
            });
          }, 5000)
        } else {
          this.checkPrview = "no";
        }
      });


  }

  item_hover_leave(asset: any, i: any) {
    clearTimeout(this.hover_debounce_time);
    this.assets_hover = false;
    this.hoveredAssetCode = {
      ...asset,
      item_hover: false
    };
    if (this.data.thumbnail_type && this.data.thumbnail_type.slug === 'enlarged-portrait') {

      this.hoverExitTimeout = setTimeout(() => {
        this.currentHoveredIndex = null;

        const activeSlides = this.owlCarouselEl.nativeElement.querySelectorAll('.owl-carousel .owl-item.active');

        activeSlides.forEach((slide: any, index: any) => {
          if (index !== this.currentHoveredIndex) { }
          this.renderer.setStyle(slide, 'width', this.assetWidth + 'px');
          // this.renderer.setStyle(slide, 'height', this.assetHeight + 'px');
        });
        const owlStage = this.owlCarouselEl.nativeElement.querySelector('.owl-carousel .owl-stage');
        this.renderer.setStyle(owlStage, 'margin-left', `0px`);
      }, 100);
    }

    if (asset.code == this.checkPrview || videojs.getPlayers()[`hoverPreviewVideo${asset?.code}`]) {
      // videojs("hoverPreviewVideo" + asset.code).dispose();
      this.isPreviewVideoMuted = true;
      this.checkPrview = "no";
    }
  }

  strToString(str: any) {
    return str?.toString();
  }

  // isPreviewVideoMuted(asset): boolean {
  //   if (asset.code == this.checkPrview && videojs("hoverPreviewVideo" + asset.code)) {
  //     const player = videojs("hoverPreviewVideo" + asset.code);
  //     return player.muted();
  //   }
  // }

  togglePreviewVideoMute(asset: any) {
    if (this.isPreviewVideoMuted) {
      videojs("hoverPreviewVideo" + asset.code).muted(false);
      this.isPreviewVideoMuted = false;
    } else {
      videojs("hoverPreviewVideo" + asset.code).muted(true);
      this.isPreviewVideoMuted = true;
    }
  }

  strToLower(str: string) {
    if (str) {
      return str.toLowerCase();
    }
    return ''
  }

  getWatchList() {
    this.playListId = localStorage.getItem('playListId')!;
    let temp = {
      playlistid: this.playListId ? this.playListId : '',
      catlogue: CatlougeTypeConstants.catlogue,
      plateform: "web",
      action: "getPlayListAsset",
    }

    let urlEncodedPlayListAssetsParams = this.UserService.convertoJSONToUrlEncoded(temp);
    this.playListService.getPlaylist().subscribe(data => {
      if (data && data.result && Array.isArray(data.result)) {
        if (Array.isArray(data.result)) {
          this.playListAvailable = true;
          this.playlist = data.result;
          return this.playlist;
        }
      }
    });

  }

  check_into_watchlist() {
    this.routeName = this.router.url;
    this.data.assets.forEach((tempAsset: any, tempIndex: any) => {

      if (this.routeName == '/') {
        this.tempAsset_id = tempAsset.asset_mongo_id
      } else if (this.routeName == '/tvshows') {
        this.tempAsset_id = tempAsset.asset_mongo_id
      } else if (this.routeName == '/movies') {
        this.tempAsset_id = tempAsset._id;
      } else if (this.routeName == '/livetv') {
        this.tempAsset_id = tempAsset._id;
      }

      if (this.playlist.findIndex((tempObj: any) => tempObj._id == this.tempAsset_id) != -1) {
        this.data.assets[tempIndex].is_watchlist_added = true;
      } else {
        this.data.assets[tempIndex].is_watchlist_added = false;
      }
    });
  }

  deleteWatchListItem(item: any) {
    this.deletedItem = item;
    if (this.routeName == '/') {
      this.deleteAsset_id = item.asset_mongo_id
    } else if (this.routeName == '/tvshows') {
      this.deleteAsset_id = item.asset_mongo_id
    } else if (this.routeName == '/movies') {
      this.deleteAsset_id = item._id;
    } else if (this.routeName == '/livetv') {
      this.deleteAsset_id = item._id;
    }


    let deletePlayListAssets = {
      playlistid: this.playListId,
      assetId: this.deleteAsset_id,
      catlogue: CatlougeTypeConstants.catlogue,
      plateform: "web",
      action: "deleteAssetFromPlaylist"
    }

    let urlEncodedToplayListParams = this.UserService.convertoJSONToUrlEncoded(deletePlayListAssets);
    this.playListService.deleteFromPlayList(urlEncodedToplayListParams).subscribe((data) => {
      this.document.getElementById('itemAddSuccessMsg')!.innerHTML = `Successfully removed From Watchlist.`;
    });

  }

  setCookie(cname: any, cvalue: any, exdays: any) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  deleteFromContinueWatching(item: any) {
    this.deleteContinueWatching.emit(item);
     // this.closeContinueModal.nativeElement.click();
    this.document.getElementById('removeContinueModal')!.style.display = 'block';
    setTimeout(() => {
      this.document.getElementById('removeContinueModal')!.style.display = 'none';
    }, 3500);
  }

  onItemHoverClick(item: any) {
    this.itemHoverClicked.emit(item);   // 🔥 send to details page
  }

  setBgImage(url: string) {
    this.bgImage = `url(${url})`;
    this.cdr.detectChanges();
  }
}